module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-item"
  }, [_c('div', {
    staticClass: "menu-item-main",
    class: {
      'menu-item-active': _vm.activeMenu === _vm.menu
    },
    style: ({
      'padding-left': _vm.paddingLeft
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.activate($event)
      }
    }
  }, [(_vm.menu.iconClass || _vm.menu.imgSrc) ? _c('i', {
    staticClass: "menu-item-icon"
  }, [_c('v-icon', {
    attrs: {
      "iconClass": _vm.menu.iconClass,
      "imgSrc": _vm.menu.imgSrc,
      "size": 16
    }
  })], 1) : (_vm.menu._deep === 0) ? _c('span', {
    staticClass: "menu-item-icon"
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "menu-item-label"
  }, [_vm._v(_vm._s(_vm.menu.label))]), _vm._v(" "), _c('span', {
    staticClass: "menu-item-sign"
  })]), _vm._v(" "), _vm._l((_vm.menu.children), function(menu) {
    return _c('menu-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.childrenVisibility),
        expression: "childrenVisibility"
      }],
      staticClass: "menu-item-child",
      attrs: {
        "menu": menu,
        "activeMenu": _vm.activeMenu,
        "useRouter": _vm.useRouter
      },
      on: {
        "menuItem_activate": _vm.emitSubActivate
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-3d28665c!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/tofu-menu/src/menu-item.vue
// module id = 641
// module chunks = 0